exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "/*---------------------------------------------------------------------------------------------\n *  Copyright (c) Microsoft Corporation. All rights reserved.\n *  Licensed under the MIT License. See License.txt in the project root for license information.\n *--------------------------------------------------------------------------------------------*/\n\n.monaco-sash {\n\tposition: absolute;\n\tz-index: 90;\n\ttouch-action: none;\n}\n\n.monaco-sash.vertical {\n\tcursor: ew-resize;\n\theight: 100%;\n\ttop: 0;\n}\n\n.monaco-sash.horizontal {\n\tcursor: ns-resize;\n\twidth: 100%;\n\tleft: 0;\n}\n\n.monaco-sash.disabled {\n\tcursor: default !important;\n}\n\n.vertical-cursor-container {\n\tcursor: ew-resize;\n}\n\n.horizontal-cursor-container {\n\tcursor: ns-resize;\n}\n\n/** Custom Mac Cursor */\n\n.monaco-sash.mac.vertical,\n.vertical-cursor-container-mac {\n\tcursor: col-resize;\n}\n\n.monaco-sash.mac.horizontal,\n.horizontal-cursor-container-mac {\n\tcursor: row-resize;\n}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./submodules/vscode/src/vs/base/browser/ui/sash/sash.css
// module id = 425
// module chunks = 0